module.exports = __webpack_public_path__ + "static/media/pp-logo-blue.58b45ab7.jpg";